export default "__VITE_ASSET__088f4fdf__"